import { render, staticRenderFns } from "./ExamMask.vue?vue&type=template&id=6cc60fce"
import script from "./ExamMask.vue?vue&type=script&lang=js"
export * from "./ExamMask.vue?vue&type=script&lang=js"
import style0 from "./ExamMask.vue?vue&type=style&index=0&id=6cc60fce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports